import { Box, IconButton, TextField, Typography } from "@mui/material";
import AppBarContainer from "../../../components/shared/AppBarContainer";
import PageContentContainer from "../../../components/shared/PageContentContainer";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRequest } from "../../../api/utils/useRequest";
import { UserAPIs } from "../../../api/APIs";
import {
  hasDigit,
  hasEnglishCharacter,
  hasLowercase,
  hasMoreThanEightChar,
  hasOneSpecialChar,
  hasRtlCharacter,
  hasUppercase,
  isPasswordValid,
} from "../../../utils/validations";
import { LoadingButton } from "@mui/lab";
import BottomFullWidthButtonContainer from "../../../components/shared/BottomFullWidthButtonContainer";
import PasswordTextField from "../../../components/shared/PasswordTextField";
import CheckValidRow from "../../../components/shared/CheckValidRow";
import { useSnackBar } from "../../../context/SnackBarContext";

function ProfileSettingChangePasswordPage() {
  const navigate = useNavigate();
  const openSnack = useSnackBar();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const { loading, apiCall: changePassword } = useRequest(
    UserAPIs.changePassword
  );

  const handleSubmit = () => {
    changePassword({
      data: {
        currentPassword,
        newPassword,
      },
      onSuccess: (response) => {
        openSnack(true, { message: "کلمه عبور جدید شما با موفقیت ثبت شد" });
        localStorage.setItem("accessToken", response.access_token);
        localStorage.setItem("refreshToken", response.refresh_token);
        navigate(-1);
      },
    });
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            تغییر کلمه عبور
          </Typography>
        }
      />
      <PageContentContainer
        sx={{
          overflow: "auto",
          display: "block",
          pb: `calc(env(safe-area-inset-bottom) + 112px )`,
        }}
      >
        <Typography variant="body2" color="grey.2">
          کلمه عبور فعلی
        </Typography>
        <PasswordTextField
          name="password"
          password={currentPassword}
          setPassword={setCurrentPassword}
        />

        <Typography mt={4} variant="body2" color="grey.2">
          کلمه عبور جدید
        </Typography>
        <PasswordTextField
          autoComplete="off"
          name="new-password"
          password={newPassword}
          setPassword={setNewPassword}
        />

        <Typography mt={4} variant="body2" color="grey.2">
          تکرار کلمه عبور
        </Typography>
        <PasswordTextField
          autoComplete="off"
          name="confirm-new-password"
          password={newPasswordConfirm}
          setPassword={setNewPasswordConfirm}
        />
        <CheckValidRow
          sx={{ my: "2px", mt: 2 }}
          isValid={
            hasEnglishCharacter(newPassword) && !hasRtlCharacter(newPassword)
          }
          title="حروف انگلیسی"
        />
        <CheckValidRow
          sx={{ my: "2px" }}
          isValid={hasMoreThanEightChar(newPassword)}
          title="حداقل ۸ کاراکتر"
        />
        <CheckValidRow
          sx={{ my: "2px" }}
          isValid={hasUppercase(newPassword)}
          title="حداقل یک حرف بزرگ"
        />
        <CheckValidRow
          sx={{ my: "2px" }}
          isValid={hasLowercase(newPassword)}
          title="حداقل یک حرف کوچک"
        />
        <CheckValidRow
          sx={{ my: "2px" }}
          isValid={hasDigit(newPassword)}
          title="حداقل یک عدد"
        />
        <CheckValidRow
          sx={{ my: "2px" }}
          isValid={hasOneSpecialChar(newPassword)}
          title="حداقل یک کاراکتر خاص (@,#,$ و ...)"
        />
        <CheckValidRow
          sx={{ my: "2px" }}
          isValid={newPassword && newPassword === newPasswordConfirm}
          title="کلمه عبور جدید با تکرار آن مطابقت داشته باشد"
        />
        <BottomFullWidthButtonContainer>
          <LoadingButton
            loading={loading}
            disabled={
              !isPasswordValid(newPassword) ||
              (newPassword && newPassword !== newPasswordConfirm) ||
              !currentPassword
            }
            onClick={handleSubmit}
            sx={{
              color: "common.white",
              typography: "h3",
            }}
            variant="contained"
            fullWidth
          >
            ثبت
          </LoadingButton>
        </BottomFullWidthButtonContainer>
      </PageContentContainer>
    </>
  );
}

export default ProfileSettingChangePasswordPage;
